import { Outlet, ScrollRestoration } from 'react-router-dom';

// ==============================|| MINIMAL LAYOUT ||============================== //

export default function MinimalLayout() {
  return (
    <>
      {/* Responsive pass (2026-10-29): each top-level layout carries one — see AppLayout. */}
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
